export const DEFAULT_ERROR_MESSAGE =
  "It seems like our AI is taking a breather and couldn't process your request. Please try resubmitting your request shortly or submit a help request for further support. We're sorry for the inconvenience and thank you for your patience";
